import React from "react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import makeCommandDispatcher from "web/core/apollo/makeCommandDispatcher";
import CartQuery from "theme/pages/Cart/CartQuery.gql";
import CartQtyQuery from "theme/layouts/Header/CartQtyQuery.gql";
import { compose, withHandlers, withProps } from "recompose";
import withDebouncedCallback from "theme/components/helpers/withDebouncedCallback";

const messages = defineMessages({
  outOfStock: {
    id: "modules.Cart.CartItem.CartItemQuantityForm.outOfStock",
    defaultMessage: "Insufficient stock for: {skus}",
  },
});

const EnhanceCartItemQuantityForm = ({ UpdateCartItemQtyMutation }) =>
  compose(
    makeCommandDispatcher({
      handleChangeItemQuantity:
        (props) =>
        ({ newQuantity, itemId }) => {
          return {
            options: {
              mutation: UpdateCartItemQtyMutation,
              variables: {
                item_id: itemId,
                qty: newQuantity,
              },
              update: (store, { data: changeItemQtyInCart }) => {
                const response = changeItemQtyInCart.changeItemQtyInCart;
                if (response.success) {
                  const cart = response.cart;
                  store.writeQuery({
                    query: CartQtyQuery,
                    data: {
                      cart: {
                        id: cart.id,
                        items_qty: cart.items_qty,
                        __typename: cart.__typename,
                      },
                    },
                  });
                  store.writeQuery({
                    query: CartQuery,
                    data: { cart: cart },
                  });
                }
              },
            },
            messages: {
              success: (
                <FormattedMessage
                  id="modules.Cart.CartItem.CartItemQuantityForm.success"
                  defaultMessage="The quantity has been updated"
                />
              ),
              error: (
                <FormattedMessage
                  id="modules.Cart.CartItem.CartItemQuantityForm.error"
                  defaultMessage="An error prevented the quantity update"
                />
              ),
            },
          };
        },
    }),
    withHandlers({
      onRefreshQuantity: (props) => (data) => {
        if (data.quantity === 0) {
          props.handleRemoveItem(props.item.item_id, props.item.qty);
          return;
        }
        if (data.quantity && data.quantity !== props.item.qty) {
          props.handleChangeItemQuantity({
            itemId: props.item.item_id,
            newQuantity: parseInt(data.quantity, 10),
          });
        }
      },
    }),
    withDebouncedCallback("onRefreshQuantity", 1000),
    injectIntl,
    withProps((props) => {
      let message =
        props.hasMessage &&
        !props.success &&
        typeof props.commandResponse !== "string" &&
        props.commandResponse.errorMessage
          ? props.commandResponse.errorMessage
          : props.message;

      if (typeof message === "string" && message.startsWith("OUT_OF_STOCK")) {
        const parts = message.split(":");
        const skus = parts.length > 1 ? parts[1].split(",") : [];
        message = props.intl.formatMessage(messages.outOfStock, {
          skus: skus.join(", "),
        });
      }

      return {
        refreshQuantityStatus: {
          commandPending: props.commandPending,
          hasMessage: props.hasMessage,
          message: message,
          success: props.success,
        },
      };
    })
  );

export default EnhanceCartItemQuantityForm;
